module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-ad-fill-539dcf26.svg";